var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('category-header',{staticClass:"z-0",attrs:{"category":_vm.category}}),_vm._v(" "),_c('category-products',{attrs:{"category":_vm.category}}),_vm._v(" "),_c('category-footer',{attrs:{"category":_vm.category}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }